import React, {useEffect} from 'react'
import { styled } from '@mui/material/styles'
import clsx from 'clsx'
import { Helmet } from 'react-helmet'
import axios from 'axios'
import Cookies from 'universal-cookie'
import { Card, CardMedia, CardContent, Grid } from '@mui/material'
import { Button, TextField } from '@mui/material'
import { Typography, IconButton, InputAdornment, Collapse, CircularProgress } from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { Alert, AlertTitle } from '@mui/material'
import { indigo } from '@mui/material/colors'

import LogoUTN from './images/logo_utn.svg'
import { CondicionesClave, verificaFortalezaClave } from '../components/CondicionClave'

const PREFIX = 'Restore'
const classes = {
  carta: `${PREFIX}-carta`,
  titulo: `${PREFIX}-titulo`,
  img: `${PREFIX}-img`,
  margin: `${PREFIX}-margin`,
  textField: `${PREFIX}-textField`,
  botonEnviar: `${PREFIX}-botonEnviar`
}

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.carta}`]: {
    marginTop: 85,
    minWidth: 250,
    width: 500,
    border: '1px solid rgba(0, 0, 0, 0.50)',
    borderRadius: '20px',
  },
  [`& .${classes.titulo}`]: {
    fontWeight: 'bolder',
    fontSize: '1.5rem',
    color: indigo[900]
  },
  [`& .${classes.img}`]: {
    objectFit: 'inherit',
    height: 120,
  },
  [`& .${classes.margin}`]: {
    margin: theme.spacing(1),
  },
  [`& .${classes.textField}`]: {
    width: '444px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  [`& .${classes.botonEnviar}`]: {
    paddingTop: '50px',
    paddingRight: '15px',
    paddingBottom: '70px',
    paddingLeft: '15px',
  }
}))

export default function Restore(props) {
  const t = global.t || {} 
  const cookies = new Cookies()

  //Se declaran los valores iniciales
  const [values, cargaValores] = React.useState({
    claveAnt: '',
    claveNuev: '',
    claveRep: '',
    mostrarClave: false,
    mensajeErrorAnt: '',
    mensajeErrorNuev: '',
    mensajeErrorRep: '',
    mensajeError: '',
    mensajeErrorAPI: '',
    mensajeAPI: '',
    ruta: props.match.params.id,
    codigoVer: props.match.params.token,
    verificado: null,
  })
  const [, cargaMensaje] = React.useState(false)
  const [valores, cargaVerificacionClave] = React.useState({})
  const [bloquearBoton, cargaEstadoBoton] = React.useState(false)

  useEffect(() => {
    verificaToken(cookies.get('_siguid') ? cookies.get('_siguid') : null)
    //El siguiente comentario, elimina la advertencia que existe una dependencia faltante en React Hook useEffect.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  //Verifica si el token del cookie existe y si es válido
  async function verificaToken(token) {
    if (token) {
      await fetch(`${process.env.REACT_APP_LOGIN_API}/verify`, {
        method: 'GET',
        headers: new Headers({
          authorization: token,
        }),
      })
      .then(async (response) => {
        if (response.status === 200) {
          cargaValores({ ...values, verificado: token.split(' ')[1] })
        }
        if (response.status !== 200) {
          cookies.remove('_siguid', {path: '/', domain:process.env.REACT_APP_DOMINIO});
          window.open('/', '_top')
        }
      })
      .catch(err => {
        cookies.remove('_siguid', {path: '/', domain:process.env.REACT_APP_DOMINIO});
        window.open('/', '_top')
      })
    }
  }

  //Inicio del manejo de las acciones
  const manejaCambioClave = (event) => {
    event.preventDefault()
    cargaMensaje(false)
    if (values.claveAnt === '' && values.verificado) {
      values.mensajeErrorAnt = t.T_CONTRASENIA_ANTERIOR || 'T_CONTRASENIA_ANTERIOR'
      cargaValores({ ...values, inputClaveAnt: values.mensajeErrorAnt })
      return
    }
    if (values.claveNuev === '') {
      values.mensajeErrorNuev = t.T_CONTRASENIA_NUEVA || 'T_CONTRASENIA_NUEVA'
      cargaValores({ ...values, inputClaveNuev: values.mensajeErrorNuev })
      return
    }
    if (values.claveRep !== '' && values.claveRep === values.claveNuev) {
      cargaEstadoBoton(true)
      const url = global.ApiUrl + '/restore/' + values.codigoVer
      const querystring = require('querystring')
      axios.put(url, querystring.stringify(values), {
        withCredentials: true,
      })
      .then(response => {
        if ( response.status === 200 ) {
          values.mensajeAPI = response.data.body
          cargaMensaje(true)
          values.mensajeAPI = ''
          setTimeout(() => {manejaVolverInicio()}, 2000)
          return
        }
      })
      .catch(error => {
        if (!error.response) {
          values.mensajeErrorAPI = t.T_ERROR_500 || 'T_ERROR_500'
        }
        else {
          values.mensajeErrorAPI = error.response.data.error
        }
        cargaEstadoBoton(false)
        cargaMensaje(true)
        values.mensajeErrorAPI = ''
        return
      })
    }
    else {
      values.mensajeErrorRep = t.T_VOLVER_INGRESAR_CONTRASENIA || 'T_VOLVER_INGRESAR_CONTRASENIA'
      cargaValores({ ...values, inputClaveRep: values.mensajeErrorRep })
    }
  }

  const manejaVolverInicio = () => {
    window.open(`${process.env.REACT_APP_DASHBOARD}/modulos`, '_top')
    return
  }

  const manejaCambio = (prop) => (event) => {
    values.mensajeErrorAnt = values.mensajeErrorNuev = values.mensajeErrorRep = ''
    if (event.target.id === 'inputClaveNuev') {
      cargaVerificacionClave (verificaFortalezaClave(event.target.value))
    }
    if ((event.target.id === 'inputClaveRep' && event.target.value !== values.claveNuev) || (event.target.id === 'inputClaveNuev' && event.target.value !== values.claveRep && values.claveRep !== '')) {
      values.mensajeErrorRep = t.T_NO_COINCIDEN_CONTRASENIAS || 'T_NO_COINCIDEN_CONTRASENIAS'
      cargaValores({ ...values, inputClaveRep: values.mensajeErrorRep })
    }
    cargaValores({ ...values, [prop]: event.target.value })
  }

  const manejaClickMostrarClave = () => {
    cargaValores({ ...values, mostrarClave: !values.mostrarClave })
  }

  const manejaMouseSobreClave = (event) => {
    event.preventDefault()
  }

  return (
    <StyledGrid container direction='row' justifyContent='center' alignItems='center'>
      <Helmet>Cambio de contraseña</Helmet>
      <Card className={clsx(classes.root, classes.carta)} elevation={6}>
        <CardMedia component='img' alt='Logo de la UTN' className={classes.img} image={LogoUTN} title='Logo UTN' />
        <CardContent>
          <Collapse in={values.mensajeErrorAPI !== '' ? true : false}>
            <Alert elevation={6} severity='error'>
              <AlertTitle>{t.T_ERROR || 'T_ERROR'}</AlertTitle>{values.mensajeErrorAPI}
            </Alert>
          </Collapse>
          <Collapse in={values.mensajeAPI !== '' ? true : false}>
            <Alert elevation={6} severity='success'>
              <AlertTitle>{t.T_CORRECTO || 'T_CORRECTO'}</AlertTitle>{values.mensajeAPI}
            </Alert>
          </Collapse>
          <Typography className={classes.titulo} color='primary' align='center' gutterBottom>{values.verificado ? (t.T_CAMBIAR_CONTRASENIA || 'T_CAMBIAR_CONTRASENIA') : (t.T_RESTAURAR_CONTRASENIA || 'T_RESTAURAR_CONTRASENIA')}</Typography>
          <Grid container direction='row' justifyContent='center' alignItems='center'>
          {values.verificado && (
            <TextField label={t.T_CONTRASENIA_ANTERIOR || 'T_CONTRASENIA_ANTERIOR'} id='inputClaveAnt' className={clsx(classes.margin, classes.textField)} type={values.mostrarClave ? 'text' : 'password'} value={values.claveAnt} onChange={manejaCambio('claveAnt')}
                error={(values.mensajeErrorAnt !== '' || /anterior/.test(values.mensajeErrorAPI))} helperText={(values.mensajeErrorAnt !== '' || /anterior/.test(values.mensajeErrorAPI)) ? (values.mensajeErrorAnt || values.mensajeErrorAPI) : ''}
                inputProps={{ maxLength: 128 }}
                InputProps={{
                  endAdornment:
                  <InputAdornment position='end'>
                    <IconButton aria-label={t.T_MOSTRAR_CONTRASENIA || 'T_MOSTRAR_CONTRASENIA'} onClick={manejaClickMostrarClave} onMouseDown={manejaMouseSobreClave} edge='end' size="large">
                      {values.mostrarClave ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }}
                variant='outlined'
              />
            )}
            <TextField label={t.T_CONTRASENIA_NUEVA || 'T_CONTRASENIA_NUEVA'} id='inputClaveNuev' className={clsx(classes.margin, classes.textField)} type={values.mostrarClave ? 'text' : 'password'} value={values.claveNuev} onChange={manejaCambio('claveNuev')}
              error={(values.mensajeErrorNuev !== '' || /estándar/.test(values.mensajeErrorAPI))} helperText={(values.mensajeErrorNuev !== '' || /estándar/.test(values.mensajeErrorAPI)) ? (values.mensajeErrorNuev || values.mensajeErrorAPI) : ''}
              inputProps={{ maxLength: 128 }}
              InputProps={{
                endAdornment:
                <InputAdornment position='end'>
                  <IconButton aria-label={t.T_MOSTRAR_CONTRASENIA || 'T_MOSTRAR_CONTRASENIA'} onClick={manejaClickMostrarClave} onMouseDown={manejaMouseSobreClave} edge='end' size="large">
                    {values.mostrarClave ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }}
              variant='outlined'
            />
            <TextField label={t.T_VOLVER_INGRESAR_CONTRASENIA || 'T_VOLVER_INGRESAR_CONTRASENIA'} id='inputClaveRep' className={clsx(classes.margin, classes.textField)} type={values.mostrarClave ? 'text' : 'password'} value={values.claveRep} onChange={manejaCambio('claveRep')}
              error={values.mensajeErrorRep !== ''} helperText={values.mensajeErrorRep !== '' ? values.mensajeErrorRep : ''}
              inputProps={{ maxLength: 128 }}
              InputProps={{
                endAdornment:
                <InputAdornment position='end'>
                  <IconButton aria-label={t.T_MOSTRAR_CONTRASENIA || 'T_MOSTRAR_CONTRASENIA'} onClick={manejaClickMostrarClave} onMouseDown={manejaMouseSobreClave} edge='end' size="large">
                    {values.mostrarClave ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }}
              variant='outlined'
            />
          </Grid>
          <Grid container direction='row' justifyContent='center' alignItems='center'>
            <CondicionesClave valores={valores} />
          </Grid>
          <Grid container direction='row' justifyContent='flex-end' alignItems='flex-end' className={classes.botonEnviar}>
            {!bloquearBoton &&
              <Button variant='contained' color='primary' onClick={manejaCambioClave} className={classes.button}>{values.verificado ? (t.T_CAMBIAR_CONTRASENIA || 'T_CAMBIAR_CONTRASENIA') : (t.T_RESTAURAR_CONTRASENIA || 'T_RESTAURAR_CONTRASENIA')}</Button>
            }
            {bloquearBoton &&
              <Typography variant='caption'><CircularProgress /> {t.T_PROCESANDO || 'T_PROCESANDO'}</Typography>
            }
          </Grid>
        </CardContent>
      </Card>
    </StyledGrid>
  )
}